import { useAppSelector } from 'hooks/useAppSelector';

export function useEssentialWorkspaceActiveTabId() {
  const tabId = useAppSelector(state => state.workspaces.workspaces.essential.activeTab);
  return tabId;
}

export function useEssentialWorkspaceActiveTabInfos() {
  const tabId = useEssentialWorkspaceActiveTabId();
  return useAppSelector(state => (tabId ? state.workspaces.essential?.[tabId] : undefined));
}
